module.exports = __webpack_public_path__ + "img/activities.40b1838.svg";